module.exports = __webpack_public_path__ + "static/media/noData.6ad8e6a3.svg";